import { render, staticRenderFns } from "./FbDebug.vue?vue&type=template&id=4d5ad1ae&scoped=true"
import script from "./FbDebug.vue?vue&type=script&lang=js"
export * from "./FbDebug.vue?vue&type=script&lang=js"
import style0 from "./FbDebug.vue?vue&type=style&index=0&id=4d5ad1ae&prod&scoped=true&lang=css"
import style1 from "./FbDebug.vue?vue&type=style&index=1&id=4d5ad1ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5ad1ae",
  null
  
)

export default component.exports